import React from 'react';
import { AlertTriangle, RefreshCw, FileEdit } from 'lucide-react';
import { Instrument } from '../types/instruments';
interface MissingInstrumentModalProps {
  missingInstruments: Instrument[];
  onRescan: () => void;
  onOverride: () => void;
}
export function MissingInstrumentModal({
  missingInstruments,
  onRescan,
  onOverride
}: MissingInstrumentModalProps) {
  const instrument = missingInstruments[0];
  if (!instrument) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" data-id="element-270">
      <div className="w-full max-w-xl bg-surface border-2 border-critical/50 rounded-modal shadow-2xl overflow-hidden" data-id="element-271">
        {/* Header */}
        <div className="bg-critical/10 border-b border-critical/30 p-8 text-center" data-id="element-272">
          <div className="inline-flex p-4 bg-critical rounded-card shadow-lg mb-4" data-id="element-273">
            <AlertTriangle className="w-10 h-10 text-white" data-id="element-274" />
          </div>
          <h2 className="text-2xl font-bold text-text-primary mb-2" data-id="element-275">
            Missing Instrument Detected
          </h2>
          <p className="text-text-secondary" data-id="element-276">
            Discrepancy identified during scan
          </p>
        </div>

        {/* Content */}
        <div className="p-8" data-id="element-277">
          <div className="bg-surface-2 rounded-card p-6 mb-6 border border-border" data-id="element-278">
            <div className="text-center" data-id="element-279">
              <div className="text-sm text-text-secondary mb-2 uppercase tracking-wide font-bold" data-id="element-280">
                Instrument Name
              </div>
              <div className="text-2xl font-bold text-text-primary mb-4" data-id="element-281">
                {instrument.name}
              </div>

              <div className="grid grid-cols-2 gap-4 text-sm" data-id="element-282">
                <div data-id="element-283">
                  <div className="text-text-secondary mb-1 uppercase tracking-wide font-bold text-xs" data-id="element-284">
                    Expected Location
                  </div>
                  <div className="font-mono text-lg text-text-primary bg-background py-2 rounded-input border border-border" data-id="element-285">
                    Slot {instrument.slot}
                  </div>
                </div>
                <div data-id="element-286">
                  <div className="text-text-secondary mb-1 uppercase tracking-wide font-bold text-xs" data-id="element-287">
                    Category
                  </div>
                  <div className="text-lg text-text-primary bg-background py-2 rounded-input border border-border" data-id="element-288">
                    {instrument.category}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="space-y-3" data-id="element-289">
            <button onClick={onRescan} className="w-full h-16 bg-critical hover:bg-red-500 text-white rounded-input font-bold text-lg shadow-lg transition-all flex items-center justify-center gap-3" data-id="element-290">
              <RefreshCw className="w-6 h-6" data-id="element-291" />
              Re-scan Tray
            </button>
            <button onClick={onOverride} className="w-full h-14 bg-surface-2 hover:bg-surface text-text-primary border border-border rounded-input font-bold text-base transition-all flex items-center justify-center gap-3" data-id="element-292">
              <FileEdit className="w-5 h-5" data-id="element-293" />
              Resolve Manually
            </button>
          </div>
        </div>
      </div>
    </div>;
}